/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Save_ContinueInputs */

const en_directory_submit_content_save_continue = /** @type {(inputs: Directory_Submit_Content_Save_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save draft & continue`)
};

const zh_directory_submit_content_save_continue = /** @type {(inputs: Directory_Submit_Content_Save_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存草稿并继续`)
};

/**
* | output |
* | --- |
* | "Save draft & continue" |
*
* @param {Directory_Submit_Content_Save_ContinueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_save_continue = /** @type {((inputs?: Directory_Submit_Content_Save_ContinueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Save_ContinueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_save_continue(inputs)
	return zh_directory_submit_content_save_continue(inputs)
});
export { directory_submit_content_save_continue as "directory.submit.content.save_continue" }